import React from 'react'
import cx from 'classnames'
import IconSVG from 'svg-inline-react'

import trashIconSrc from '!svg-inline!images/svg/close.svg'
import upIconSrc from '!svg-inline!images/svg/paragraph-up.svg'
import downIconSrc from '!svg-inline!images/svg/paragraph-down.svg'
import pencilIconSrc from '!svg-inline!images/svg/pencil.svg'

import './style.styl'

const Card = ({
  title,
  children,
  className,
  onMoveUpClick,
  onMoveDownClick,
  onDeleteClick,
  onEditClick,
  narrowHeader,
}) =>
  <div className={cx('playbook-card', className)}>
    <header className={cx('playbook-card-header', 'flex-space-between', { narrow: narrowHeader })}>
      {!narrowHeader &&
        <div className="color-white dsg-Body dsg-medium-weight truncate">{title}</div>
      }
      <div>
        {onMoveUpClick &&
          <IconSVG
            className="playbook-card-action"
            onClick={onMoveUpClick}
            src={upIconSrc}
          />
        }
        {onMoveDownClick &&
          <IconSVG
            className="playbook-card-action"
            onClick={onMoveDownClick}
            src={downIconSrc}
          />
        }
        {onEditClick &&
          <IconSVG
            className="playbook-card-action"
            onClick={onEditClick}
            src={pencilIconSrc}
          />
        }
        {onDeleteClick &&
          <IconSVG
            className="playbook-card-action"
            onClick={onDeleteClick}
            src={trashIconSrc}
          />
        }
      </div>
    </header>
    <div onClick={onEditClick} className={cx('playbook-card-content', { editable: !!onEditClick })}>
      {children}
    </div>
  </div>

export default Card



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Card/index.js